import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { interval } from 'rxjs';
import { Banner, IBanner } from 'src/app/interfaces/banner.interfaces';
import { ReplyAlbumart, ReplySong } from 'src/app/interfaces/music.interface';
import { Station } from 'src/app/interfaces/station.interface';
import { BannerService } from 'src/app/services/banner.service';
import { SongService } from 'src/app/services/song.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent implements OnInit {

  @Input() station: Station;
  urlAudio = environment.audioUrl || '';
  idStationEnv = environment.idStation || '';
  imageStation = environment.imageStation || '';
  config = environment.config.type;
  showPlayer: boolean = false;

  audio = new Audio();
  playFlag: boolean = false;

  iBanner: IBanner = null
  banner: Banner[] = null

  imgBannerAlbumart: String = null
  urlImage = environment.urlApi + "/view/image/banner/name/"

  replysong: ReplySong = null
  replyAlbumart: ReplyAlbumart = null
  auxSong:String = null;
  auxArtista:String = null;

  flagBanner: boolean = false

  constructor(
    private _songService:SongService,
    private bannerService: BannerService,
  ) { }

  ngOnInit() {
    if (this.config != '1') {
      this.configureStationMode(this.idStationEnv);
    } else {
      this.showPlayer = false;
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['station'] && this.station) {
      this.getSongGrupoAs();
    }
  }

  configureStationMode(idStationEnv: string | null) {
    this.showPlayer = true;
    if (!idStationEnv) {
      this.songCurrent()
      this.albumart()
      this.bannerActive()
      const seconds = interval(90000)
  
      seconds.subscribe( respCurrentSong => {
        this.songCurrent();
        this.albumart();
      });
    } else {
      this.getSongGrupoAs();
    }
  }

  getSongGrupoAs(){
    if(this.station){
      this.auxArtista = this.station.nombre;
      this.auxSong = this.station.frecuencia;
    }
  }

  songCurrent(){
    this._songService.getSongCurrent().subscribe(resp => {
      this.replysong = resp

      if(this.flagBanner == true){
        this.cutSong(resp.artista, resp.cancion, 17)
      }else{
        this.cutSong(resp.artista, resp.cancion, 25)
      }

    })
  }

  albumart(){
    this._songService.getAlbumart().subscribe(resp => {
      this.replyAlbumart = resp
    })
  }

  playAudio() {
    const streamUrl = this.station 
    ? this.station.ip 
    : this.urlAudio;

    this.audio.src = streamUrl;    
    this.audio.load();
    this.audio.play();
    this.playFlag = true;
  }

  pauseAudio() {
    this.audio.pause();
    this.playFlag = false;
  }

  toggleAudio(){
    if(this.playFlag == true){
      this.pauseAudio();
    }else{
      this.playAudio();
    }
  }

  bannerActive() {
  this.bannerService.getActive().subscribe(resp => {
    this.iBanner = resp;
    this.banner = resp.banner;

    if (this.iBanner.elementos > 0) {
      this.flagBanner = true;
      this.updateBannerImages();
    }
  });
}

  updateBannerImages() {
    let index = 0;

    const cycleBanners = () => {
      if (index < this.banner.length) {
        this.imgBannerAlbumart = this.banner[index].imagen;
        index++;
        setTimeout(cycleBanners, 10000);
      } else {
        this.flagBanner = false;
        this.resetBanner();
      }
    };

    setTimeout(cycleBanners, 2000);
  }

  resetBanner() {
    if (this.replysong) {
      this.cutSong(this.replysong.artista, this.replysong.cancion, 20);
    }
    setTimeout(() => this.bannerActive(), 300000);
  }

  cutSong(textArtista: string, textSong: string, length: number) {
    this.auxArtista = textArtista.length > length 
      ? textArtista.substring(0, length) + "..." 
      : textArtista;

    this.auxSong = textSong.length > length 
      ? textSong.substring(0, length) + "..." 
      : textSong;
  }

}
